import React, { useState, Fragment, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import {
    selectDeviceName,
    selectPreferences,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import ImagemapBanner from 'yoda-core-components/lib/components/ImagemapBannerResponsive/ImagemapBannerResponsive';
import ImageBanner from 'yoda-core-components/lib/components/Banner/Banner';
import { getPromoBanner } from 'yoda-interfaces/lib/Pdp/PromoBannerS1Api';
import { constructSEODefaultCanonicalUrl } from 'yoda-site-components/lib/helpers/Utils/seoHelper';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const defaultState = {
    isSuccess: false,
    imageUrl: '',
    imageAltText: '',
    imagemapArea: [],
    imageWidth: '',
    imageHeight: '',
};
function IrisS1ClientPromoBanner({
    productDetails,
    ppId,
    tmplType,
    automationId,
    deviceName,
    topPromotionalBanner,
    preferences,
}) {
    const [state, setState] = useState(defaultState);

    useEffect(() => {
        let canonicalUrl = (productDetails.meta && productDetails.meta.canonicalUrl) || '';
        if (!__SERVER__ && !canonicalUrl) {
            const {
                seoConfig: { excludeQueryParams = [], includeQueryParams = [] } = {},
            } = preferences;
            canonicalUrl = constructSEODefaultCanonicalUrl(
                !__SERVER__ && window ? window.location.href : '',
                excludeQueryParams,
                includeQueryParams,
                false
            );
            canonicalUrl = canonicalUrl.replace(/^.*\/p\//, '/p/');
        }
        if (canonicalUrl) {
            canonicalUrl = canonicalUrl.substring(0, canonicalUrl.indexOf('?'));
            getPromoBanner({
                ppid: ppId,
                pTmplType: tmplType,
                channel: deviceName,
                canonicalUrl,
                headers: productDetails.headers,
            }).then((res) => {
                const bannerData = get(res, 'content.components[0].content.channels[0]', null);
                const componentType = get(res, 'content.components[0].componentType', '');
                /* istanbul ignore next */
                if (bannerData) {
                    const {
                        image: {
                            dimensions: { width = '', height = '' } = {},
                            url = '',
                            altText = '',
                        } = {},
                        link: { url: linkUrl = '' } = {},
                        linkText = '',
                        openInNewTab = false,
                        hotspots = [],
                    } = bannerData;
                    setState({
                        ...state,
                        isSuccess: true,
                        componentType,
                        imageUrl: url,
                        imageAltText: altText,
                        imageWidth: width,
                        imageHeight: height,
                        imagelinkUrl: linkUrl,
                        imagelinkText: linkText,
                        imageOpenNewTab: openInNewTab,
                        imagemapArea: hotspots.map((hotspot = {}) => {
                            // eslint-disable-next-line no-shadow
                            const { link = {}, linkText, openInNewTab } = hotspot;
                            const hotspotData = { ...hotspot };
                            if (link.url) {
                                hotspotData.leaf = !link.url.includes('X2H2');
                                hotspotData.link = link.url;
                            }
                            hotspotData.alt = linkText;
                            hotspotData.target = openInNewTab ? '_blank' : '_self';
                            return hotspotData;
                        }),
                    });
                }
            });
        }
    }, []);
    const topbannerSpaceStyle = dt(['my-2', 'mx-0', 'pt-0']);
    return (
        <>
            {state.isSuccess ? (
                <ErrorBoundary>
                    <div
                        data-automation-id="topbannerSpace"
                        className={topPromotionalBanner && topbannerSpaceStyle}
                    >
                        {state.componentType === 'imagehotspots' ? (
                            <ImagemapBanner
                                automationId={automationId}
                                imageUrl={state.imageUrl}
                                imagemapArea={state.imagemapArea}
                                imageAltText={state.imageAltText}
                                imageWidth={state.imageWidth}
                                imageHeight={state.imageHeight}
                            />
                        ) : (
                            <ImageBanner
                                automationId={automationId}
                                bannerImageUrl={state.imageUrl}
                                bannerImageClass={dt(['!h-25'])}
                                ariaLabel={state.imagelinkText}
                                altText={state.imagelinkText}
                                width={state.imageWidth}
                                height={state.imageHeight}
                                href={state.imagelinkUrl}
                                target={state.imageOpenNewTab ? '_blank' : ''}
                            />
                        )}
                    </div>
                </ErrorBoundary>
            ) : null}
        </>
    );
}

IrisS1ClientPromoBanner.propTypes = {
    productDetails: PropTypes.object,
    automationId: PropTypes.string,
    ppId: PropTypes.string,
    tmplType: PropTypes.bool,
    deviceName: PropTypes.string,
    topPromotionalBanner: PropTypes.bool,
    preferences: PropTypes.object,
};

IrisS1ClientPromoBanner.defaultProps = {
    productDetails: {},
    automationId: 'banner-content',
    ppId: '',
    tmplType: false,
    deviceName: 'Desktop',
    topPromotionalBanner: false,
    preferences: {},
};

const mapStateToProps = (state) => ({
    deviceName: selectDeviceName(state),
    preferences: selectPreferences(state),
});

export default memo(connect(mapStateToProps)(IrisS1ClientPromoBanner));
